<template>
  <div class="inventario-detalhes">
    <v-container justify-center align-center fluid class="container">
      <Card
        v-if="objeto !== undefined"
        v-bind:title="objeto.nome"
        v-bind:text="objeto.codigo">
        <div class="descfield" v-if="objeto.descricao">
          <h2 class="label">Descrição</h2>
          {{objeto.descricao}}
        </div>
        <div class="verifssection" v-if="local">
          <hr>
          <h2 class="label">Última Verificação</h2>
          <VerificacaoInventario v-bind:objeto="objeto" v-bind:status="status"></VerificacaoInventario>
        </div>
        <div class="usossection" v-if="usos">
          <hr>
          <h2 class="label">Usos</h2>
          <UsoInventario v-for="uso in objeto.usos" v-bind:key="uso.codigo" v-bind:uso="uso"></UsoInventario>
        </div>
      </Card>
      <Card
        v-if="objeto === undefined && objetos.length !== 0"
        title="Erro"
        color="red">
        Não foi possível encontrar este item
      </Card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import UsoInventario from '@/components/UsoInventario.vue'
import VerificacaoInventario from '@/components/VerificacaoInventario.vue'
import Card from '@/components/Card.vue'
import { db } from '../main'

function compararDataInicio (a, b) {
  if (!a.inicio || !b.inicio || new Date(a.inicio.seconds * 1000) < new Date(b.inicio.seconds * 1000)) return 1
  if (new Date(a.inicio.seconds * 1000) > new Date(b.inicio.seconds * 1000)) return -1
  return 0
}

function compararDataLocal (a, b) {
  if (!a.data || !b.data || new Date(a.data.seconds * 1000) > new Date(b.data.seconds * 1000)) return 1
  if (new Date(a.data.seconds * 1000) < new Date(b.data.seconds * 1000)) return -1
  return 0
}

function computarStatus (obj) {
  if (!obj.ativo) {
    return 'desativado'
  }
  const dataAtual = new Date()
  const lastCheck = new Date(obj.local[obj.local.length - 1].data.seconds * 1000)
  const usos = []
  for (let i = 0; i < obj.usos.length; i++) {
    usos.push(obj.usos[i])
  }
  usos.sort(compararDataInicio)
  // Vetor usos está sortado por data de inicio
  for (let i = usos.length - 1; i >= 0; i--) {
    if (dataAtual > new Date(usos[i].inicio.seconds * 1000) && dataAtual < new Date(usos[i].termino.seconds * 1000)) {
      return 'em uso'
    }
    if (i > 0 && dataAtual > new Date(usos[i].termino.seconds * 1000) && dataAtual < new Date(usos[i - 1].inicio.seconds * 1000)) {
      if (lastCheck < new Date(usos[i].termino.seconds * 1000)) {
        return 'requer verificacao e uso agendado'
      } else {
        return 'uso agendado'
      }
    }
    if (usos.length === 1 && dataAtual < new Date(usos[i].inicio.seconds * 1000)) {
      return 'uso agendado'
    }
    // console.log(i + "/" + String(usos.length-1))
    // console.log(dataAtual)
    // console.log(new Date(usos[i].termino.seconds * 1000))
    // console.log(lastCheck)
    if (i === 0 && dataAtual > new Date(usos[i].termino.seconds * 1000) && lastCheck < new Date(usos[i].termino.seconds * 1000)) {
      return 'requer verificacao'
    }
  }
  return 'situacao regular'
}

export default {
  name: 'detalhesinventario',
  components: {
    UsoInventario,
    VerificacaoInventario,
    Card
  },
  props: ['objetoid'],
  data () {
    return {
      objetos: []
    }
  },
  computed: {
    objeto: function () {
      return this.objetos.find(x => x.codigo === this.objetoid)
    },
    usos: function () {
      return Array.prototype.slice.call(this.objeto.usos).sort(compararDataInicio)
    },
    local: function () {
      return Array.prototype.slice.call(this.objeto.local).sort(compararDataLocal)
    },
    status: function () {
      return computarStatus(this.objeto)
    }
  },
  mounted () {
    this.$bind('objetos', db.collection('inventario'))
  }
}
</script>

<style scoped>
.nomeobjeto {
  font-size: 2rem;
  margin-top: 5px;
  margin-bottom: 0px;
  color: black;
}

.codigoobjeto {
  margin: 0px;
  font-weight: normal;
  font-size: 1.5rem;
}

.label {
  font-size: 1rem;
  font-style: normal;
  margin-bottom: 0.25em;
}

.title {
  margin-bottom: 20px;
}

.usossection {
  margin-top: 0.25rem;
  font-size: 1rem;
}

.descfield {
  margin-bottom: 20px;
  font-style: italic;
}

.editbutton::v-deep {
  font-size: 1em;
  height: 2em;
  width: fit-content;
  padding-left: 10px;
  padding-right: 10px;
}

.editbutton {
  margin-top: 10px;
}

.container {
  max-width: 800px;
}
</style>
